module.exports = __webpack_public_path__ + "img/20180314_111617-min.4bb0b6ad.jpg";